import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useState } from 'react';
import { BaseIntegrationForm } from './BaseIntegrationForm';
import { useIntegrationForm } from '@/hooks/useIntegrationForm';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Loader2 } from 'lucide-react';

export function ActiveCampaignForm() {
  useLanguage();
  const { selectedVideo, setSelectedVideo, videos, isLoadingVideos, handleSubmit, isSubmitting } =
    useIntegrationForm('activecampaign', 'ActiveCampaign', 'leads');

  const [formData, setFormData] = useState({
    endpoint_url: '',
    api_key: '',
  });

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await handleSubmit({
      ...formData,
      id_video: selectedVideo?.id || '',
    });
  };

  const handleChange = (field: string, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  if (isLoadingVideos) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-6 w-6 animate-spin text-gray-500" />
      </div>
    );
  }

  return (
    <BaseIntegrationForm onSubmit={onSubmit}>
      <div className="space-y-2">
        <Label htmlFor="endpoint_url" className="text-[14px] font-medium text-[#374151]">
          {translateInterfaceText("Webhook URL")}</Label>
        <Input
          id="endpoint_url"
          name="endpoint_url"
          type="url"
          placeholder="https://youraccountname.api-us1.com/admin/api.php"
          value={formData.endpoint_url}
          onChange={(e) => handleChange('endpoint_url', e.target.value)}
          required
          className="h-10"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="api_key" className="text-[14px] font-medium text-[#374151]">
          {translateInterfaceText("Token")}</Label>
        <Input
          id="api_key"
          name="api_key"
          type="text"
          placeholder={translateInterfaceText("sua_chave_api_do_activecampaign")}
          value={formData.api_key}
          onChange={(e) => handleChange('api_key', e.target.value)}
          required
          className="h-10"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="video" className="text-[14px] font-medium text-[#374151]">
          {translateInterfaceText("Selecione o Vídeo")}</Label>
        <Select
          value={selectedVideo?.id || ''}
          onValueChange={(value) => {
            const video = videos.find((v) => v.id === value);
            if (video) setSelectedVideo(video);
          }}
        >
          <SelectTrigger className="h-10">
            <SelectValue placeholder={translateInterfaceText("Escolha um vídeo")} />
          </SelectTrigger>
          <SelectContent>
            {videos.map((video) => (
              <SelectItem key={video.id} value={video.id}>
                {video.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {isSubmitting && (
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>{translateInterfaceText("Salvando...")}</span>
        </div>
      )}
    </BaseIntegrationForm>
  );
}
